import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";
import type { ChampMetier } from "../../types/champMetier";

interface UseGetChampsMetierOptions
  extends Omit<UseQueryOptions<ChampMetier[], Error>, "queryKey" | "queryFn"> {}

/**
 * Hook to fetch all ChampMetier (business fields)
 * GET /iam/champs-metier/
 */
export const useGetChampsMetier = (options: UseGetChampsMetierOptions = {}) => {
  return useQuery<ChampMetier[], Error>({
    queryKey: ["champsMetier"],
    queryFn: async () => {
      console.log("[useGetChampsMetier] Fetching champs métier...");

      const response = await fetchClient<ChampMetier[]>("/iam/champs-metier/");

      if (response.error) {
        const errorMessage =
          response.error.detail ||
          response.error.non_field_errors?.[0] ||
          "Failed to fetch champs métier";
        throw new Error(errorMessage);
      }

      if (!response.data) {
        console.warn("[useGetChampsMetier] No data received");
        return [];
      }

      console.log(
        "[useGetChampsMetier] Successfully fetched",
        response.data.length,
        "champs métier"
      );
      return response.data;
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
    ...options,
  });
};
